/**
 * Auto-generated from dark-roast enum types — string-literal union types
 * derived from the Java backend's wire enum values. Do not edit manually.
 * Regenerate with: yarn sync-entities
 */

export enum SovrenParsingStatus {
  SUCCESS = "SUCCESS",
  FAILED = "FAILED",
  UNABLE = "UNABLE",
}

export const SovrenParsingStatusDisplay: Record<SovrenParsingStatus, string> = {
  [SovrenParsingStatus.SUCCESS]: "Success",
  [SovrenParsingStatus.FAILED]: "Failed",
  [SovrenParsingStatus.UNABLE]: "Unable",
};
